
const baseJson = () => {
    return {
        _id: null,
        name: null,
        ngayBatDau: null,
        ngayKetThuc: null,
        ngayBatDauShow: null,
        ngayKetThucShow: null,
        gioBatDau: null,
        gioKetThuc: null,
        latitude: null,
        longitude: null,
        file: null,
        diaChi: null,
        chuTri: null,
        thamMuu: null,
        daiBieu: null,
        phoiHop: null,
        noiDungs: []
    };
};
const toJson = (item) => {
    if (!item) return baseJson();

    return {
        _id: item._id,
        name: item.name,
        ngayBatDau: item.ngayBatDau,
        ngayKetThuc: item.ngayKetThuc,
        ngayBatDauShow: item.ngayBatDauShow,
        ngayKetThucShow: item.ngayKetThucShow,
        gioBatDau: item.gioBatDau,
        gioKetThuc: item.gioKetThuc,
        latitude: item.latitude,
        longitude: item.longitude,
        file: item.file ? {
            fileId: item.file.fileId || null,
            fileName: item.file.fileName || null,
            ext: item.file.ext || null,
            path: item.file.path || null
        } : null,
        diaChi: item.diaChi,
        chuTri: item.chuTri,
        thamMuu: item.thamMuu,
        daiBieu: item.daiBieu,
        phoiHop: item.phoiHop,
        noiDungs: Array.isArray(item.noiDungs) ? item.noiDungs.map(nd => ({
            text: nd.text || null,
            icon: nd.icon || "info"
        })) : []
    };
};
const fromJson = (item) => {
    if (!item) return baseJson();
    return {
        _id: item._id,
        name: item.name,
        ngayBatDau: item.ngayBatDau,
        ngayKetThuc: item.ngayKetThuc,
        ngayBatDauShow: item.ngayBatDauShow,
        ngayKetThucShow: item.ngayKetThucShow,
        gioBatDau: item.gioBatDau,
        gioKetThuc: item.gioKetThuc,
        latitude: item.latitude,
        longitude: item.longitude,
        file: item.file ? {
            fileId: item.file.fileId || null,
            fileName: item.file.fileName || null,
            ext: item.file.ext || null,
            path: item.file.path || null
        } : null,
        diaChi: item.diaChi,
        chuTri: item.chuTri || null,
        thamMuu: item.thamMuu || null,
        daiBieu: item.daiBieu || null,
        phoiHop: item.phoiHop || null,
        noiDungs: Array.isArray(item.noiDungs) ? item.noiDungs.map(nd => ({
            text: nd.text || null,
            icon: nd.icon || "info"
        })) : []
    };
};


export const chuongTrinhModel = {
    baseJson,
    fromJson,
    toJson,
};
